{
  "wallboard": {
    "instances_count": "no instances | {count} instance | {count} instances",
    "label": "Wallboard"
  }
}
